const te = {
  nav: {
    home: "హోమ్",
    salons: "సెలూన్లు",
    membership: "సభ్యత్వం",
    shop: "షాప్",
    academy: "అకాడమీ",
    blog: "జర్నల్",
    login: "లాగిన్",
    logout: "లాగ్ అవుట్",
    dashboard: "డాష్‌బోర్డ్",
    bookings: "నా బుకింగ్‌లు",
    loyalty: "లాయల్టీ",
    profile: "ప్రొఫైల్",
    orders: "నా ఆర్డర్లు",
    chat: "చాట్‌లు",
    notifications: "నోటిఫికేషన్లు",
    partner: "భాగస్వామి",
    admin: "అడ్మిన్",
    partner_panel: "భాగస్వామి ప్యానెల్",
    admin_panel: "అడ్మిన్ ప్యానెల్",
    login_register: "లాగిన్ / నమోదు",
    skip_to_content: "కంటెంట్‌కి వెళ్లండి",
    account_menu: "ఖాతా మెను",
    primary_nav: "ప్రధానం",
    mobile_nav: "మొబైల్ నావిగేషన్",
    ai_advisor: "AI సలహాదారు",
    cart: "షాపింగ్ కార్ట్",
  },
  footer: {
    tagline: "భారతదేశపు ప్రీమియం సెలూన్ బుకింగ్ ప్లాట్‌ఫారమ్ — లగ్జరీ అందాన్ని మీ చేతికి తెస్తున్నాం.",
    company: "కంపెనీ",
    about: "మా గురించి",
    how_it_works: "ఇది ఎలా పని చేస్తుంది",
    partners: "భాగస్వాముల కోసం",
    stylists: "స్టైలిస్టుల కోసం",
    careers: "కెరీర్లు",
    contact: "సంప్రదించండి",
    support: "సపోర్ట్",
    faq: "తరచుగా అడిగే ప్రశ్నలు",
    help: "హెల్ప్ సెంటర్",
    privacy: "గోప్యతా విధానం",
    terms: "సేవా నిబంధనలు",
    refund: "రీఫండ్ విధానం",
    services: "సేవలు",
    salons: "సెలూన్లు",
    membership: "సభ్యత్వం",
    shop: "షాప్",
    academy: "అకాడమీ",
    connect: "కనెక్ట్",
    newsletter_title: "మా న్యూస్‌లెటర్‌లో చేరండి",
    newsletter_sub: "బ్యూటీ చిట్కాలు, ప్రత్యేక ఆఫర్లు, స్పామ్ లేదు.",
    newsletter_placeholder: "మీ ఇమెయిల్",
    newsletter_cta: "సబ్‌స్క్రైబ్ చేయండి",
    copyright: "© {{year}} Fayriza. అన్ని హక్కులూ కలిగి ఉన్నాయి.",
    made_in: "భారతదేశంలో రూపొందించబడింది",
  },
  home: {
    hero_eyebrow: "భారతదేశపు ప్రీమియం సెలూన్ నెట్‌వర్క్",
    hero_title: "మీ పర్ఫెక్ట్ సెలూన్ అనుభవాన్ని కనుగొనండి",
    hero_subtitle: "మీ సమీపంలోని టాప్ రేటెడ్ సెలూన్లలో అపాయింట్‌మెంట్లు బుక్ చేసుకోండి — లగ్జరీ, సౌకర్యం, శ్రద్ధ.",
    search_placeholder: "సెలూన్లు, సేవలు లేదా స్టైలిస్టులను శోధించండి…",
    search_cta: "సెలూన్ కనుగొనండి",
    featured_salons: "ఫీచర్డ్ సెలూన్లు",
    browse_all: "అన్నీ బ్రౌజ్ చేయండి",
    view_all: "అన్నీ చూడండి",
    categories_title: "వర్గాలను అన్వేషించండి",
    categories_sub: "ప్రతి సందర్భానికీ అనువైన సేవలు",
    why_title: "Fayriza ఎందుకు",
    why_sub: "మొదటి నుండి చివరి వరకు ప్రీమియం అనుభవం",
    why_1_title: "ధృవీకరించబడిన సెలూన్లు",
    why_1_body: "ప్రతి భాగస్వామి సెలూన్ జాగ్రత్తగా ఎంపిక చేయబడి, నాణ్యత పరీక్షించబడుతుంది.",
    why_2_title: "తక్షణ బుకింగ్",
    why_2_body: "రియల్-టైమ్ లభ్యత, క్షణాల్లో ధృవీకరణ.",
    why_3_title: "సురక్షిత చెల్లింపులు",
    why_3_body: "Razorpay మద్దతుతో, రీఫండ్-రక్షిత లావాదేవీలు.",
    why_4_title: "లాయల్టీ & రివార్డులు",
    why_4_body: "ప్రతి సందర్శనకు పాయింట్లు సంపాదించండి, ప్రయోజనాల కోసం రీడీమ్ చేయండి.",
    testimonials_title: "మా కమ్యూనిటీ ప్రేమిస్తోంది",
    cta_title: "మెరవడానికి సిద్ధమా?",
    cta_sub: "వేలాది Fayriza సభ్యులలో చేరండి.",
    cta_btn: "ప్రారంభించండి",
  },
  salons: {
    title: "అన్ని సెలూన్లు",
    subtitle: "మీ సమీపంలోని ప్రీమియం భాగస్వామి సెలూన్లను బ్రౌజ్ చేయండి",
    filter: "ఫిల్టర్",
    sort: "క్రమీకరించండి",
    sort_relevance: "సంబంధితత్వం",
    sort_rating: "అత్యధిక రేటింగ్",
    sort_price_asc: "ధర: తక్కువ నుండి ఎక్కువ",
    sort_price_desc: "ధర: ఎక్కువ నుండి తక్కువ",
    sort_nearest: "సమీపం",
    search_placeholder: "పేరు లేదా ప్రాంతం ద్వారా శోధించండి…",
    categories_all: "అన్నీ",
    city_all: "అన్ని నగరాలు",
    price_range: "ధర పరిధి",
    open_now: "ఇప్పుడు తెరిచి ఉంది",
    no_results_title: "మీ ఫిల్టర్లకు సరిపోయే సెలూన్లు లేవు",
    no_results_sub: "ఒక ఫిల్టర్‌ను క్లియర్ చేయడానికి లేదా వేరే ప్రాంతాన్ని శోధించడానికి ప్రయత్నించండి.",
    clear_filters: "ఫిల్టర్లను క్లియర్ చేయండి",
    showing: "{{count}} సెలూన్లు చూపుతోంది",
    loading: "సెలూన్లు లోడ్ అవుతున్నాయి…",
    book_now: "ఇప్పుడే బుక్ చేయండి",
    from: "నుండి",
    per_service: "ఒక్కో సేవకు",
    results: "ఫలితాలు",
    filters_title: "ఫిల్టర్లు",
    reset_all: "అన్నీ రీసెట్ చేయండి",
    category: "వర్గం",
    min_rating: "కనీస రేటింగ్",
    any_rating: "ఏదైనా రేటింగ్",
    for_gender: "ఎవరికోసం",
    gender_women: "మహిళలు",
    gender_men: "పురుషులు",
    gender_unisex: "అన్ని వర్గాలకు",
    cat_bridal: "వధువు",
    cat_spa: "స్పా",
  },
  salon: {
    book_now: "ఇప్పుడే బుక్ చేయండి",
    message: "సందేశం",
    favourite: "ఇష్టాల్లో చేర్చండి",
    unfavourite: "ఇష్టాల నుండి తీసివేయండి",
    share: "షేర్ చేయండి",
    directions: "దిశలు",
    call: "కాల్ చేయండి",
    services: "సేవలు",
    stylists: "స్టైలిస్టులు",
    reviews: "సమీక్షలు",
    availability: "లభ్యత",
    gallery: "గ్యాలరీ",
    about: "గురించి",
    working_hours: "పని గంటలు",
    amenities: "సౌకర్యాలు",
    contact: "సంప్రదించండి",
    overview: "అవలోకనం",
    location: "లొకేషన్",
    reviews_count: "{{count}} సమీక్షలు",
    rating_out_of: "5లో {{rating}}",
    select_service: "బుక్ చేయడానికి సేవను ఎంచుకోండి",
    duration: "వ్యవధి",
    minutes: "{{min}} నిమి",
    open: "తెరిచి ఉంది",
    closed: "మూసి ఉంది",
    closes_at: "{{time}}కి మూసివేస్తారు",
    opens_at: "{{time}}కి తెరుస్తారు",
  },
  booking: {
    title: "అపాయింట్‌మెంట్ బుక్ చేయండి",
    step_services: "సేవలు",
    step_stylist: "స్టైలిస్ట్",
    step_datetime: "తేదీ & సమయం",
    step_review: "సమీక్ష",
    step_pay: "చెల్లింపు",
    select_services: "సేవలను ఎంచుకోండి",
    select_stylist: "స్టైలిస్ట్‌ను ఎంచుకోండి",
    any_stylist: "అందుబాటులో ఉన్న ఏ స్టైలిస్ట్ అయినా",
    select_date: "తేదీని ఎంచుకోండి",
    select_time: "సమయాన్ని ఎంచుకోండి",
    no_slots: "ఈ తేదీకి స్లాట్లు అందుబాటులో లేవు",
    try_other_date: "వేరే తేదీని ప్రయత్నించండి",
    confirm: "బుకింగ్ ధృవీకరించండి",
    cancel: "బుకింగ్ రద్దు చేయండి",
    reschedule: "తిరిగి షెడ్యూల్ చేయండి",
    subtotal: "ఉప మొత్తం",
    discount: "తగ్గింపు",
    tax: "పన్నులు & రుసుములు",
    total: "మొత్తం",
    pay_now: "ఇప్పుడే చెల్లించండి",
    pay_at_salon: "సెలూన్‌లో చెల్లించండి",
    use_wallet: "వాలెట్ ఉపయోగించండి",
    apply_offer: "ఆఫర్ వర్తింపజేయండి",
    offer_placeholder: "కోడ్‌ను నమోదు చేయండి",
    apply: "వర్తింపజేయండి",
    remove: "తీసివేయండి",
    booking_confirmed: "బుకింగ్ ధృవీకరించబడింది!",
    booking_cancelled: "బుకింగ్ రద్దు చేయబడింది",
    booking_ref: "బుకింగ్ ID",
    when: "ఎప్పుడు",
    where: "ఎక్కడ",
    who: "ఎవరితో",
    notes: "గమనిక జోడించండి (ఐచ్ఛికం)",
    notes_placeholder: "అలెర్జీలు, ప్రాధాన్యతలు…",
    upcoming: "రాబోయేవి",
    past: "గతంలోనివి",
    cancelled: "రద్దు చేయబడినవి",
    view_details: "వివరాలు చూడండి",
    download_receipt: "రసీదు డౌన్‌లోడ్ చేయండి",
    rate_visit: "ఈ సందర్శనను రేట్ చేయండి",
  },
  auth: {
    login_title: "తిరిగి స్వాగతం",
    login_sub: "Fayrizaకి కొనసాగడానికి సైన్ ఇన్ చేయండి",
    register_title: "ఖాతా సృష్టించండి",
    register_sub: "భారతదేశపు ప్రీమియం సెలూన్ నెట్‌వర్క్‌లో చేరండి",
    email: "ఇమెయిల్",
    email_placeholder: "you@example.com",
    password: "పాస్‌వర్డ్",
    password_placeholder: "కనీసం 8 అక్షరాలు",
    phone: "ఫోన్ నంబర్",
    phone_placeholder: "10-అంకెల మొబైల్ నంబర్",
    name: "పూర్తి పేరు",
    name_placeholder: "మీ పేరు",
    otp: "OTP నమోదు చేయండి",
    otp_placeholder: "6-అంకెల కోడ్",
    send_otp: "OTP పంపండి",
    verify_otp: "ధృవీకరించండి",
    resend_otp: "OTP మళ్లీ పంపండి",
    resend_in: "{{s}}సెకన్లలో మళ్లీ పంపండి",
    login_cta: "సైన్ ఇన్",
    register_cta: "ఖాతా సృష్టించండి",
    forgot_password: "పాస్‌వర్డ్ మర్చిపోయారా?",
    reset_password: "పాస్‌వర్డ్ రీసెట్ చేయండి",
    reset_sub: "మీ ఇమెయిల్‌ను నమోదు చేయండి, మేము రీసెట్ లింక్‌ను పంపుతాము",
    reset_sent: "రీసెట్ లింక్ మీ ఇమెయిల్‌కి పంపబడింది",
    new_password: "కొత్త పాస్‌వర్డ్",
    confirm_password: "పాస్‌వర్డ్ ధృవీకరించండి",
    social_login: "లేదా దీనితో కొనసాగండి",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    verify_email: "ఇమెయిల్ ధృవీకరించండి",
    verify_email_sub: "{{email}}కి మేము ధృవీకరణ లింక్ పంపాము",
    resend_email: "ధృవీకరణ ఇమెయిల్ మళ్లీ పంపండి",
    accept_terms: "నేను నిబంధనలు మరియు గోప్యతా విధానానికి అంగీకరిస్తున్నాను",
    switch_to_register: "ఖాతా లేదా?",
    switch_to_register_cta: "సైన్ అప్ చేయండి",
    switch_to_login: "ఇప్పటికే ఖాతా ఉందా?",
    switch_to_login_cta: "సైన్ ఇన్",
    remember_me: "నన్ను గుర్తుంచుకోండి",
    phone_or_email: "ఫోన్ లేదా ఇమెయిల్",
    use_phone: "బదులుగా ఫోన్ ఉపయోగించండి",
    use_email: "బదులుగా ఇమెయిల్ ఉపయోగించండి",
  },
  profile: {
    title: "నా ప్రొఫైల్",
    edit_profile: "ప్రొఫైల్ సవరించండి",
    change_password: "పాస్‌వర్డ్ మార్చండి",
    avatar: "ప్రొఫైల్ ఫోటో",
    upload_photo: "ఫోటో అప్‌లోడ్ చేయండి",
    name: "పూర్తి పేరు",
    phone: "ఫోన్ నంబర్",
    email: "ఇమెయిల్",
    dob: "పుట్టిన తేదీ",
    gender: "లింగం",
    gender_male: "పురుషుడు",
    gender_female: "స్త్రీ",
    gender_other: "ఇతర",
    address: "చిరునామా",
    city: "నగరం",
    pincode: "పిన్‌కోడ్",
    save: "మార్పులను సేవ్ చేయండి",
    saved: "ప్రొఫైల్ అప్‌డేట్ చేయబడింది",
    current_password: "ప్రస్తుత పాస్‌వర్డ్",
    current_password_placeholder: "ప్రస్తుత పాస్‌వర్డ్‌ను నమోదు చేయండి",
    new_password: "కొత్త పాస్‌వర్డ్",
    new_password_placeholder: "కనీసం 8 అక్షరాలు",
    password_changed: "పాస్‌వర్డ్ విజయవంతంగా మార్చబడింది",
  },
  dashboard: {
    title: "డాష్‌బోర్డ్",
    welcome: "తిరిగి స్వాగతం, {{name}}",
    upcoming_bookings: "రాబోయే బుకింగ్‌లు",
    no_upcoming: "రాబోయే అపాయింట్‌మెంట్లు లేవు",
    book_a_salon: "సెలూన్ బుక్ చేయండి",
    favourites: "ఇష్టమైన సెలూన్లు",
    no_favourites: "మీరు ఇంకా ఏ సెలూన్‌నూ ఇష్టపడలేదు",
    loyalty_points: "లాయల్టీ పాయింట్లు",
    wallet_balance: "వాలెట్ బ్యాలెన్స్",
    recent_activity: "ఇటీవలి కార్యకలాపం",
    quick_actions: "త్వరిత చర్యలు",
    view_all: "అన్నీ చూడండి",
    manage_membership: "సభ్యత్వాన్ని నిర్వహించండి",
    top_up_wallet: "వాలెట్ టాప్ అప్ చేయండి",
    refer_friend: "స్నేహితుడిని రిఫర్ చేయండి",
  },
  common: {
    loading: "లోడ్ అవుతోంది…",
    error: "ఏదో తప్పు జరిగింది",
    retry: "మళ్లీ ప్రయత్నించండి",
    no_results: "ఫలితాలు కనుగొనబడలేదు",
    search: "శోధన",
    filter: "ఫిల్టర్",
    sort: "క్రమీకరించండి",
    view_all: "అన్నీ చూడండి",
    see_more: "మరింత చూడండి",
    see_less: "తక్కువ చూడండి",
    back: "వెనుక",
    next: "తర్వాత",
    previous: "మునుపటి",
    submit: "సమర్పించండి",
    cancel: "రద్దు చేయండి",
    delete: "తొలగించండి",
    edit: "సవరించండి",
    save: "సేవ్ చేయండి",
    close: "మూసివేయండి",
    confirm: "ధృవీకరించండి",
    continue: "కొనసాగించండి",
    yes: "అవును",
    no: "కాదు",
    skip: "దాటవేయండి",
    optional: "ఐచ్ఛికం",
    required: "తప్పనిసరి",
    from: "నుండి",
    per: "ఒక్కో",
    to: "వరకు",
    and: "మరియు",
    or: "లేదా",
    learn_more: "మరింత తెలుసుకోండి",
    coming_soon: "త్వరలో వస్తోంది",
    currency: "₹",
    minutes_short: "నిమి",
    hours_short: "గం",
    km: "కి.మీ",
    away: "దూరంలో",
    stars: "నక్షత్రాలు",
  },
  loyalty: {
    title: "Fayriza లాయల్టీ",
    subtitle: "ప్రతి సందర్శనకు పాయింట్లు సంపాదించండి, రివార్డుల కోసం రీడీమ్ చేయండి",
    points: "పాయింట్లు",
    available_points: "అందుబాటులోని పాయింట్లు",
    total_earned: "మొత్తం సంపాదించినవి",
    total_redeemed: "మొత్తం రీడీమ్ చేసినవి",
    redeem: "రీడీమ్ చేయండి",
    history: "పాయింట్ల చరిత్ర",
    rewards: "రివార్డులు",
    tier: "స్థాయి",
    how_it_works: "ఇది ఎలా పని చేస్తుంది",
    earn_title: "సంపాదించండి",
    earn_body: "ప్రతి ₹10 ఖర్చుకు 1 పాయింట్. గోల్డ్‌లో 2×, ప్లాటినమ్‌లో 3×.",
    redeem_title: "రీడీమ్ చేయండి",
    redeem_body: "వాలెట్ క్రెడిట్, ఉచిత సేవలు లేదా భాగస్వామి ప్రయోజనాల కోసం పాయింట్లను ఉపయోగించండి.",
    empty_history: "ఇంకా పాయింట్ల కార్యకలాపం లేదు",
    empty_rewards: "ప్రస్తుతం రివార్డులు అందుబాటులో లేవు",
  },
  wallet: {
    title: "Fayriza వాలెట్",
    subtitle: "ఒక్కసారి టాప్ అప్ చేయండి, ఇబ్బంది లేకుండా బుక్ చేయండి",
    balance: "బ్యాలెన్స్",
    available: "అందుబాటులో",
    topup: "టాప్ అప్",
    topup_cta: "డబ్బు జోడించండి",
    topup_amount: "మొత్తం",
    history: "లావాదేవీ చరిత్ర",
    empty_history: "ఇంకా లావాదేవీలు లేవు",
    credit: "క్రెడిట్",
    debit: "డెబిట్",
    refund: "రీఫండ్",
  },
  membership: {
    eyebrow: "ప్రత్యేక యాక్సెస్",
    hero_title: "Fayriza సభ్యత్వ ప్లాన్లు",
    hero_sub: "భారతదేశంలోని 500+ ప్రీమియం సెలూన్లలో ప్రత్యేక తగ్గింపులు, ప్రాధాన్యతా బుకింగ్ మరియు లగ్జరీ ప్రయోజనాలను అన్‌లాక్ చేయండి.",
    plans: "సభ్యత్వ ప్లాన్లు",
    subscribe: "సబ్‌స్క్రైబ్ చేయండి",
    cancel: "సభ్యత్వాన్ని రద్దు చేయండి",
    current: "ప్రస్తుత ప్లాన్",
    gold: "గోల్డ్",
    silver: "సిల్వర్",
    platinum: "ప్లాటినమ్",
    per_year: "/సంవత్సరానికి",
    per_month_approx: "≈ ₹{{amount}}/నెలకి",
    cancel_anytime: "ఎప్పుడైనా రద్దు చేయండి",
    choose_title: "మీ ప్లాన్‌ను ఎంచుకోండి",
    choose_sub: "అన్ని ప్లాన్లు వార్షికంగా బిల్ చేయబడతాయి. ప్లాన్‌ను ఎంచుకుని తక్షణమే సక్రియం చేయడానికి ధృవీకరించండి.",
    most_popular: "అత్యంత ప్రజాదరణ",
    get_plan: "{{plan}} పొందండి",
    selected_proceed: "ఎంచుకోబడింది — చెల్లింపుకు కొనసాగండి →",
    processing: "ప్రాసెస్ అవుతోంది…",
    current_plan_label: "✓ ప్రస్తుత ప్లాన్",
    welcome_back: "తిరిగి స్వాగతం, {{name}}!",
    member_label: "Fayriza {{tier}} సభ్యుడు",
    expires_in: "{{days}} రోజుల్లో గడువు ముగుస్తుంది",
    renews_on: "{{date}}న పునరుద్ధరించబడుతుంది",
    your_discount: "మీ తగ్గింపు",
    off_all: "అన్ని సేవలపై",
    expiring_warn: "మీ సభ్యత్వం త్వరలో ముగియనుంది. తగ్గింపులను కొనసాగించడానికి ఇప్పుడే పునరుద్ధరించండి.",
    feature_comparison: "పూర్తి ఫీచర్ పోలిక",
    feature: "ఫీచర్",
    benefits_500: "500+ భాగస్వామి సెలూన్లు",
    benefits_instant: "తక్షణ సక్రియం",
    benefits_cancel: "ఎప్పుడైనా రద్దు చేయండి",
    benefits_refund: "7-రోజుల మనీ బ్యాక్",
    faq_title: "తరచుగా అడిగే ప్రశ్నలు",
    faq_cancel_q: "నేను నా సభ్యత్వాన్ని రద్దు చేయవచ్చా?",
    faq_cancel_a: "అవును. మీరు ఎప్పుడైనా మీ డాష్‌బోర్డ్ నుండి రద్దు చేయవచ్చు. మీ బిల్లింగ్ కాలం ముగిసే వరకు మీ ప్రయోజనాలు కొనసాగుతాయి.",
    faq_all_salons_q: "తగ్గింపు అన్ని సెలూన్లకు వర్తిస్తుందా?",
    faq_all_salons_a: "అవును — భారతదేశవ్యాప్తంగా ధృవీకరించబడిన Fayriza యొక్క 500+ భాగస్వామి సెలూన్లన్నింటిలో తగ్గింపు స్వయంచాలకంగా వర్తిస్తుంది.",
    faq_refund_q: "7-రోజుల మనీ బ్యాక్ గ్యారెంటీ అంటే ఏమిటి?",
    faq_refund_a: "సక్రియం అయిన 7 రోజుల్లో మీరు సంతృప్తి చెందకపోతే, మేము మీ సభ్యత్వ ఫీజును పూర్తిగా తిరిగి చెల్లిస్తాము — ఎటువంటి ప్రశ్నలూ లేకుండా.",
    faq_upgrade_q: "నేను నా ప్లాన్‌ను అప్‌గ్రేడ్ చేయవచ్చా?",
    faq_upgrade_a: "అవును. మీరు ఎప్పుడైనా అప్‌గ్రేడ్ చేయవచ్చు. మిగిలిన కాలానికి సంబంధించి ప్రొరేటెడ్ వ్యత్యాసం వసూలు చేయబడుతుంది.",
    activated: "🎉 Fayriza {{plan}} సక్రియం చేయబడింది!",
    subscribe_failed: "సబ్‌స్క్రిప్షన్ విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
  },
  shop: {
    eyebrow: "Fayriza షాప్",
    hero_title: "ప్రీమియం బ్యూటీ & గ్రూమింగ్ ఉత్పత్తులు",
    hero_sub: "క్యూరేటెడ్ ప్రొఫెషనల్-గ్రేడ్ అత్యవసర వస్తువులు, మీ తలుపు వద్దకే డెలివరీ.",
    search_placeholder: "ఉత్పత్తులను శోధించండి…",
    categories: "వర్గాలు",
    all_products: "అన్ని ఉత్పత్తులు",
    add_to_cart: "కార్ట్‌కి జోడించండి",
    added: "జోడించబడింది ✓",
    out_of_stock: "స్టాక్‌లో లేదు",
    checkout: "చెక్అవుట్",
    cart: "కార్ట్",
    cart_empty: "మీ కార్ట్ ఖాళీగా ఉంది",
    cart_empty_sub: "దాన్ని నింపడానికి షాపింగ్ ప్రారంభించండి",
    products: "ఉత్పత్తులు",
    orders: "నా ఆర్డర్లు",
    no_orders: "ఇంకా ఆర్డర్లు లేవు",
    order_ref: "ఆర్డర్ ID",
    order_status: "స్థితి",
    order_placed: "ఉంచబడింది",
    order_shipped: "పంపబడింది",
    order_delivered: "డెలివరీ చేయబడింది",
    order_cancelled: "రద్దు చేయబడింది",
    qty: "పరిమాణం",
    remove: "తీసివేయండి",
    subtotal: "ఉప మొత్తం",
    shipping: "షిప్పింగ్",
    tax: "పన్ను",
    total: "మొత్తం",
    proceed_checkout: "చెక్అవుట్‌కు కొనసాగండి",
    shipping_address: "షిప్పింగ్ చిరునామా",
    place_order: "ఆర్డర్ ఉంచండి",
    continue_shopping: "షాపింగ్ కొనసాగించండి",
    product_details: "ఉత్పత్తి వివరాలు",
    description: "వివరణ",
    specifications: "స్పెసిఫికేషన్లు",
    you_may_like: "మీకు కూడా ఇష్టం కావచ్చు",
    related: "సంబంధిత ఉత్పత్తులు",
  },
  academy: {
    eyebrow: "Fayriza అకాడమీ",
    hero_title: "భారతదేశపు ఉత్తమ స్టైలిస్టుల నుండి నేర్చుకోండి",
    hero_sub: "సర్టిఫైడ్ నిపుణులచే బోధించబడే ప్రొఫెషనల్ బ్యూటీ & గ్రూమింగ్ కోర్సులు. మీ స్వంత వేగంతో నేర్చుకోండి, సర్టిఫికేట్లు సంపాదించండి, మీ కెరీర్‌ను ప్రారంభించండి.",
    search_placeholder: "కోర్సులు లేదా శిక్షకులను శోధించండి…",
    stats_courses: "నిపుణుల కోర్సులు",
    stats_students: "నమోదైన విద్యార్థులు",
    stats_rating: "సగటు రేటింగ్",
    stats_certificate: "సర్టిఫికేట్ చేర్చబడింది",
    all: "అన్ని కోర్సులు",
    makeup: "మేకప్",
    hair: "హెయిర్",
    skin: "స్కిన్",
    nails: "నెయిల్స్",
    grooming: "గ్రూమింగ్",
    courses: "కోర్సులు",
    course: "కోర్సు",
    enroll: "ఇప్పుడే నమోదు చేయండి",
    enrolled: "నమోదు చేయబడింది",
    modules: "మాడ్యూళ్లు",
    instructor: "శిక్షకుడు",
    duration: "వ్యవధి",
    level: "స్థాయి",
    level_beginner: "ప్రారంభకుడు",
    level_intermediate: "మధ్యస్థ",
    level_advanced: "అధునాతన",
    certificate: "సర్టిఫికేట్",
    no_courses: "మీ ఫిల్టర్లకు సరిపోయే కోర్సులు లేవు",
    my_enrollments: "నా కోర్సులు",
    continue_learning: "నేర్చుకోవడం కొనసాగించండి",
    completed: "పూర్తయింది",
  },
  notifications: {
    title: "నోటిఫికేషన్లు",
    empty: "మీరు అన్నీ చూశారు",
    empty_sub: "ప్రస్తుతం కొత్త నోటిఫికేషన్లు లేవు",
    mark_all_read: "అన్నింటినీ చదివినట్లు గుర్తు పెట్టండి",
    just_now: "ఇప్పుడే",
    minutes_ago: "{{n}}ని క్రితం",
    hours_ago: "{{n}}గం క్రితం",
    days_ago: "{{n}}రో క్రితం",
  },
  ai: {
    title: "Fayriza AI సలహాదారు",
    subtitle: "AI చే శక్తివంతమైన వ్యక్తిగత బ్యూటీ సిఫార్సులు.",
    placeholder: "చర్మం, జుట్టు, మేకప్ గురించి ఏదైనా అడగండి…",
    send: "పంపండి",
    examples_title: "ఇలా అడిగి చూడండి",
    ex_1: "నా ముఖ ఆకృతికి ఉత్తమ హెయిర్‌కట్?",
    ex_2: "జిడ్డు చర్మానికి స్కిన్‌కేర్ రొటీన్",
    ex_3: "2026 పెళ్లి మేకప్ ట్రెండ్‌లు",
    thinking: "ఆలోచిస్తోంది…",
    disclaimer: "సూచనలు సమాచార ప్రయోజనాల కోసమే. వైద్య సమస్యల కోసం నిపుణుడిని సంప్రదించండి.",
  },
  marketing: {
    about: {
      eyebrow: "మా కథ",
      title: "అందం, మళ్లీ ఊహించబడింది",
      sub: "Fayriza ఒక సాధారణ ఆలోచన నుండి పుట్టింది — భారతదేశం తన కళకు తగిన శుద్ధమైన సెలూన్ బుకింగ్ అనుభవానికి అర్హమైనది.",
      mission_title: "మా లక్ష్యం",
      mission_body: "కోట్లాది బ్యూటీ ప్రేమికులను భారతదేశపు అత్యుత్తమ సెలూన్లతో సున్నితమైన, విశ్వసనీయమైన మరియు లగ్జరీ ప్లాట్‌ఫారమ్ ద్వారా కలపడం.",
      vision_title: "మా దృష్టి",
      vision_body: "ప్రతి ఒక్కరికీ నాణ్యమైన బ్యూటీ మరియు వెల్‌నెస్ సేవలు చేతికి అందుబాటులో ఉండే ప్రపంచం.",
      values_title: "మా విలువలు",
      value_1_title: "నాణ్యతే ముందుగా",
      value_1_body: "ప్రతి భాగస్వామి సెలూన్ ధృవీకరించబడి మా ప్రీమియం ప్రమాణాలకు కట్టుబడి ఉంటుంది.",
      value_2_title: "కస్టమర్ కేంద్రీకృతం",
      value_2_body: "మీ అనుభవమే మా మార్గదర్శకం — బుకింగ్ నుండి అనంతర సంరక్షణ వరకు.",
      value_3_title: "భాగస్వాములను శక్తివంతం చేయడం",
      value_3_body: "మా సెలూన్లు మరియు స్టైలిస్టులు పెరిగినప్పుడే మేము పెరుగుతాము.",
      cta_title: "ఈ కథలో భాగం అవ్వండి",
      cta_sub: "ఈరోజే Fayriza కమ్యూనిటీలో చేరండి.",
    },
    how_it_works: {
      eyebrow: "ఇది ఎలా పని చేస్తుంది",
      title: "మూడు దశల్లో బుక్ చేయండి",
      sub: "అనుమానాలు లేని ప్రీమియం అందం.",
      step_1_title: "కనుగొనండి",
      step_1_body: "మీ సమీపంలోని ధృవీకరించబడిన సెలూన్లు, సేవలు మరియు స్టైలిస్టులను బ్రౌజ్ చేయండి.",
      step_2_title: "బుక్ చేయండి",
      step_2_body: "మీకు అనువైన సమయాన్ని ఎంచుకోండి — తక్షణమే ధృవీకరించబడుతుంది.",
      step_3_title: "ఆనందించండి",
      step_3_body: "సేదతీరండి. మీ సందర్శనను రేట్ చేయండి. రివార్డులు సంపాదించండి.",
      faq_title: "త్వరిత ప్రశ్నలు",
    },
    partners: {
      eyebrow: "సెలూన్ యజమానుల కోసం",
      title: "Fayrizaతో ఎదగండి",
      sub: "కొత్త కస్టమర్లను చేరుకోండి, ఖాళీ కుర్చీలను నింపండి, మరియు ఆధునిక సెలూన్‌ను నిర్వహించండి.",
      benefit_1_title: "మరిన్ని కస్టమర్లు",
      benefit_1_body: "భారతదేశపు అతిపెద్ద ప్రీమియం బ్యూటీ ప్రేక్షకులను చేరుకోండి.",
      benefit_2_title: "స్మార్ట్ బుకింగ్",
      benefit_2_body: "షెడ్యూల్‌లు, సిబ్బంది మరియు సేవలను ఒకే డాష్‌బోర్డ్ నుండి నిర్వహించండి.",
      benefit_3_title: "తక్షణ చెల్లింపులు",
      benefit_3_body: "సురక్షితమైన, వేగవంతమైన చెల్లింపులు — మాన్యువల్‌గా వెంబడించాల్సిన అవసరం లేదు.",
      cta: "భాగస్వామి అవ్వండి",
    },
    stylists: {
      eyebrow: "స్టైలిస్టుల కోసం",
      title: "మీ క్లయింటేలాను నిర్మించుకోండి",
      sub: "మీ పనిని ప్రదర్శించండి, గుర్తింపు పొందండి, మరియు మీ కెరీర్‌ను పెంచుకోండి.",
      cta: "స్టైలిస్ట్‌గా దరఖాస్తు చేయండి",
    },
    careers: {
      eyebrow: "కెరీర్లు",
      title: "అందపు భవిష్యత్తును రూపొందించండి",
      sub: "మేము పెద్దదాన్ని నిర్మిస్తున్న చిన్న బృందం. చేరతారా?",
      openings_title: "తెరిచి ఉన్న పాత్రలు",
      no_openings: "ప్రస్తుతం ఖాళీలు లేవు. careers@fayriza.comకి మాకు ఒక నోట్ పంపండి.",
    },
    contact: {
      eyebrow: "సంప్రదించండి",
      title: "మీ నుండి వినడానికి మాకు ఇష్టం",
      sub: "ప్రశ్నలు, అభిప్రాయం లేదా భాగస్వామ్య ఆలోచనలు — మేము అన్నీ వింటాము.",
      name: "మీ పేరు",
      email: "మీ ఇమెయిల్",
      message: "సందేశం",
      send: "సందేశం పంపండి",
      sent: "ధన్యవాదాలు — మేము 24 గంటల్లో తిరిగి వస్తాము.",
      support_email: "సపోర్ట్",
      partners_email: "భాగస్వాములు",
      media_email: "మీడియా",
    },
    faq: {
      eyebrow: "సహాయం",
      title: "తరచుగా అడిగే ప్రశ్నలు",
      sub: "సాధారణ ప్రశ్నలకు త్వరిత సమాధానాలు.",
    },
    legal: {
      privacy_title: "గోప్యతా విధానం",
      terms_title: "సేవా నిబంధనలు",
      refund_title: "రీఫండ్ విధానం",
      last_updated: "చివరిగా అప్‌డేట్ చేయబడింది {{date}}",
    },
  },
  errors: {
    network: "నెట్‌వర్క్ లోపం — మీ కనెక్షన్‌ను తనిఖీ చేయండి",
    unauthorised: "కొనసాగడానికి దయచేసి సైన్ ఇన్ చేయండి",
    forbidden: "దీనికి మీకు యాక్సెస్ లేదు",
    not_found: "మీరు వెతుకుతున్నది మాకు కనుగొనబడలేదు",
    server: "సర్వర్ లోపం — దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి",
    validation: "దయచేసి హైలైట్ చేసిన ఫీల్డులను తనిఖీ చేయండి",
    generic: "ఏదో తప్పు జరిగింది",
    page_not_found_title: "పేజీ కనుగొనబడలేదు",
    page_not_found_sub: "మీరు వెతుకుతున్న పేజీ తరలించబడింది లేదా ఇకపై లేదు.",
    go_home: "హోమ్‌కి వెళ్లండి",
  },
};

export default te;
